export const enum LanguageLevel {
    Basic = "Basic",
    Beginner = "Beginner",
    Intermediate = "Intermediate",
    Advanced = "Advanced",
    Fluent = "Fluent",
    Native = "Native"
}

export const enum Http {
    GET = "GET",
    POST = "POST",
    PUT = "PUT",
    DELETE = "DELETE",
    PATCH = "PATCH",
}

export const enum Period {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
}

export const enum CardBackgroundOption {
    VideoOrImage = 0,
    Image = 1,
    Nothing = 2,
}

export const enum Voice {
    gb = "gb",
    us = "us",
}

export const enum ContentType {
    Image = "Image",
    Video = "Video",
}

export const enum AnimationType {
    SlideRight = "slideRight",
    SlideUp = "slideUp",
    SlideDown = "slideDown",
    SlideLeft = "slideLeft",
    RotateRight = "rotateRight",
    RotateLeft = "rotateLeft",
    RotateIn = "rotateIn",
    RotateOut = "rotateOut",
}

export const enum MenuPosition {
    BottomLeft = "bottom-left",
    BottomRight = "bottom-right",
    TopLeft = "top-left",
    TopRight = "top-right",
}

export const PathName = {
    learn: "/learn",
    search: "/search",
    progress: "/progress",
    wordlists: "/wordlists",
    lessons: "/lessons",
}

export const enum ResponseType {
    Json = "json",
    Text = "text",
}

export const enum HttpMethod {
    GET = "GET",
    POST = "POST",
    PUT = "PUT",
    DELETE = "DELETE",
    PATCH = "PATCH",
}

export const enum LearnWizardStep {
    First = "FirstWizard",
    Second = "SecondWizard",
    Third = "ThirdWizard",
    Final = "FinalWizard",
}

export enum LearningArray {
    KnownWordIds = "KnownWordIds",
    UnknownWordIds = "UnknownWordIds",
    ToLearn = "ToLearn",
    ReviewWordIds = "ReviewWordIds",
}

export enum Actions {
    Learn = "learn",//unknown
    Knew = "knew",
    Remembered = "remembered",
    Forgot = "forgot",
    ScheduleReview = "schedule-review",

    LessonCompleted = "lesson-completed",
    LessonQuestionAdded = "lesson-question-add",
    LessonAnswerAdded = "lesson-answer-add",

    NewWordList = "new-word-list",
    RenameWordList = "rename-word-list",
    RemoveWordList = "remove-word-list",
    InsertWordToList = "insert-word-to-list",
    RemoveWordFromList = "remove-word-from-list",
    SeenWordList = "seen-word-list",

    ScenarioCompleted = "scenario-completed",
    ScenarioChallengeAdded = "scenario-challenge-add",


    EarnHeart = "earn-heart",
    LoseHeart = "lose-heart",

    HardwareInfo = "Hardware-info",
    SeenGuides = "Seen-guides",
    AddSeconds = "add-seconds",

    UserData = "user-data",

}

export enum Direction {
    Prev = 'prev',
    Next = 'next'
}

export enum WordListType {
    Custom = 'custom',
    Subject = 'subject',
    All = 'all'
}

export enum LoadingStatus {
    IDLE = 'idle',
    LOADING = 'loading',
    SUCCEEDED = 'succeeded',
    FAILED = 'failed'
}

export enum Examples {
    Quotes = "Quotes",
    News = "News",
    WordsOfWisdom = "WordsOfWisdom",
    InterestingFacts = "InterestingFacts",
    YouTube = "YouTube",
}

export enum LessonArrays {
    CompletedContext = "CompletedContext",
    Conversations = "Conversations",
    Answers = "Answers",
}

export enum ScenarioArrays {
    CompletedContext = "CompletedContext",
    Challenges = "Challenges",
}

export enum DarkMode {
    Dark = "dark",
    Light = "light",
}

export enum NoteSQSType {
    Add = 0,
    Edit = 1,
    Delete = 2,
}

export enum PageSource {
    Learn = "Learn",
    Search = "Search",
    Discover = "Discover",
    Challenge = "Challenge",
    Definition = "Definition",
    EranHeart = "EranHeart",
    Chat = "Chat",
}

export enum DiscoverView {
    Cards = "cards",
    Tags = "tags",
    List = "list",
}

export enum ChevronType {
    Left = "left",
    Right = "right",
    Up = "up",
    Down = "down",
}

export enum SortType {
    Alphabetic = "Alphabetic",
    HardestFirst = "Hardest First",
    EasiestFirst = "Easiest First",
}

export enum Pages {
    Definition = "Definition",
    Scenario = "Scenario",
}

export enum SpecialWordListId {
    Known = "-100",
    ToLearn = "-101",
    Unknown = "-102"
}

export enum AgeGroup {
    Adult = "Adult",
    Teenager = "Teenager",
    Child = "Child"
}

export enum HeartType {
    DailyFree = "DailyFree",
    Friend = "Friend",
    Ad = "Ad",
    Discover = "Discover"
}

export enum CardType {
    Learn = "learn",
    Challenge = "challenge"
}

export enum CardStatus {
    Pending = "pending",
    Completed = "completed",
    Skipped = "skipped"
}

export enum AnswerType {
    IncorrectAnswer = "IncorrectAnswer",
    CorrectAnswer = "CorrectAnswer"
}

export enum ButtonType {
    ShouldLearn = "shouldLearn",
    AlreadyKnew = "alreadyKnew"
}

export enum Guides {
    UserWordsUncover = "UserWords-Uncover",
    DiscoverFirstVisit = "Discover-FirstVisit",
    ScenarioChallenge = "scenario-challenge",
    ChatInput = "Chat-Input",
    LessonsFirstVisit = "Lessons-FirstVisit",
    ConsecutiveKnew = "Consecutive-Knew",
    AvatarSelection = "Avatar-Selection",
    ChatTitle = "Chat-Title",
    PracticeFirstVisit = "Practice-FirstVisit",
    ContextLessonsFirstVisit = "ContextLessons-FirstVisit",
    FreeTrial7d = "FreeTrial-7d",
    DiscoverSelect = "Discover-Select",
    DiscoverFirstUnknown = "Discover-FirstUnknown",
    ChallengeNewCard = "Challenge-NewCard",
    ChallengeNewCardDismiss = "Challenge-NewCardDismiss",
    DiscoverTitle = "Discover-Title",
    DiscoverMap = "Discover-Map",
    FreeTrial6d = "FreeTrial-6d",
    ChallengeChallengeCard = "Challenge-ChallengeCard",
    FreeTrial5d = "FreeTrial-5d",
    FreeTrial3d = "FreeTrial-3d",
    ProgressView = "ProgressView",
    WordSound = "WordSound",
    IdiomsHighlight = "Idioms-Highlight",
    ReviewCardWordLearningProgress = "ReviewCard-WordLearning-Progress",
    ChatNext = "Chat-Next",
    NonIranianAppLikingSurvey = "NonIranian_App_Liking_Survey",
    ConsecutiveLearn = "Consecutive-Learn"
}

export enum UserMessage {
    ClearCache = "clear-cache",
    FinishAds = "finish-ads",
    SuccessAddFriend = "success-add-friend",
}

export enum IFrameMessage {
    SmartWord = "SMART_WORD",
    UserMessage = "USER_MESSAGE",
    NavigationToDomain = "NAVIGATION_TO_DOMAIN",
    NavigationBackCompleted = "NAVIGATION_BACK_COMPLETED",
    NavigationCompleted = "NAVIGATION_COMPLETED",
    WritingFeedback = "WRITING_FEEDBACK",
}


export enum ChatTypes {
    WordChat = "word-chat",
    Writing = "writing",
    GeneralChat = "general-chat",

}